/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignCenterIcon20Solid = forwardRef('TextAlignCenterIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 3a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M5 8a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 11a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M6 15a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H6Z" })));
});
